// extracted by mini-css-extract-plugin
module.exports = {"grey_dark":"#8A93A6","profile-user__notfound":"style_profile-user__notfound__21k96"};